module.exports = __webpack_public_path__ + "static/media/47abb7e8-7ca2-4634-8b1f-e42525a2182e.c0d5a954.webp";